import CryptoJS from "crypto-js";

const wordArrayToByteArray = (hash: any) => {
  return hash.words
    .map(function (v: any) {
      const bytes = [0, 0, 0, 0]
        .slice(0, Math.min(4, hash.sigBytes))
        .map(function (_, i) {
          return (v >>> (8 * i)) % 256;
        })
        .reverse();
      hash.sigBytes -= bytes.length;
      return bytes;
    })
    .reduce(function (a: any, d: any) {
      return a.concat(d);
    }, [])
    .map(function (d: any) {
      return String.fromCharCode(d);
    })
    .join("");
};

const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

const Base64 = {
  btoa: (input = "") => {
    let str = input;
    let output = "";

    for (
      let block = 0, charCode, i = 0, map = chars;
      str.charAt(i | 0) || ((map = "="), i % 1);
      output += map.charAt(63 & (block >> (8 - (i % 1) * 8)))
    ) {
      charCode = str.charCodeAt((i += 3 / 4));
      block = (block << 8) | charCode;
    }

    return output;
  }
};

const computeHash = (message: string, secret: string, truncate?: boolean) => {
  const parsedWordArray = CryptoJS.enc.Base64.parse(secret);
  const hash = CryptoJS.HmacSHA256(message, parsedWordArray);
  const result = wordArrayToByteArray(hash);
  return Base64.btoa(truncate ? result.slice(0, 16) : result);
};

const generateXHmacHeader = (url: string, secret: string) => computeHash(url.substring(url.indexOf("?") + 1), secret);

const hashUtils = {
  computeHash,
  generateXHmacHeader
};

export default hashUtils;
